export const SOURCE_STRINGS = {
  Aktualne: 'Aktuálně.cz',
  Vareni: 'Vaření.cz',
  Woman: 'Žena.cz',
  Respekt: 'Respekt',
  Nova: 'TN.cz',
  Utulne: 'Útulně',
  Video: 'Aktuálně.cz',
  Magazin: 'Aktuálně.cz',
  MagazinZahrada: 'Magazín zahrada',
  AktualneAuto: 'Aktuálně.cz',
  VyberMiAuto: 'VybermiAuto.cz',
  VitalWeb: 'Vitalweb.cz',
  CzechSight: 'CzechSight',
  Sip: 'Sip',
  Kondice: 'Kondice',
  Kinotip: 'Kinotip',
  Kafe: 'Kafe',
  Dotyk: 'Dotyk',
  Zdrave: 'Zdravě',
  Jsme: 'Jsme',
  FajntipLifestyle: 'Fajntip',
  FajntipPsychologie: 'Fajntip',
  Ireceptar: 'iReceptář',
  Ekonom: 'Ekonom'
}

export const SOURCE_IMAGES = {
  Aktualne: 'aktualne.svg',
  Vareni: 'vareni.svg',
  Woman: 'zena.svg',
  Respekt: 'respekt.svg',
  Nova: 'tn.svg',
  Utulne: 'utulne.svg',
  Video: 'aktualne.svg',
  Magazin: 'aktualne.svg',
  MagazinZahrada: 'magazinzahrada.png',
  AktualneAuto: 'aktualne.svg',
  VyberMiAuto: 'vybermiauto.svg',
  VitalWeb: 'vitalweb.svg',
  CzechSight: 'czechsight.png',
  Sip: 'sip.png',
  Kondice: 'kondice.png',
  Kinotip: 'kinotip.png',
  Kafe: 'kafe.png',
  Dotyk: 'dotyk.png',
  Zdrave: 'zdrave.svg',
  Jsme: 'jsme.ico',
  FajntipLifestyle: 'fajntip.png',
  FajntipPsychologie: 'fajntip.png',
  Ireceptar: 'ireceptar.png',
  Ekonom: 'ekonom.svg'
}

export const ALREADY_USED_ARTICLES_WIDGETS = [
  'dynamiclead',
  'news',
  'video',
  'woman',
  'sport',
  'magazine',
  'finance',
  'newsfeed',
  'celebritiesInverted'
]
